/* this file is transformed by vux-loader */
/* eslint-disable */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      orderNo: '',
      price: ''
    };
  },
  created: function created() {
    var orderNo = this.$route.query.orderNo,
        price = this.$route.query.price;
    this.orderNo = orderNo || '';
    this.price = price || '';
  },
  components: {},
  computed: {},
  methods: {
    goMall: function goMall() {
      this.$router.push({
        name: 'MallIndex'
      });
    },
    //查看订单详情
    goOrderDetail: function goOrderDetail() {
      var orderNo = this.orderNo;
      this.$router.push({
        name: 'MallOrderDetail',
        query: {
          orderNo: orderNo
        }
      });
    }
  }
};